import { useState } from 'react';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';

export default function usePipelineIntegrationSelect() {
  const {
    pipeline: { pipelineIntegrations },
  } = usePipelinePageContext();

  const [selectedPipelineIntegrationId, setSelectedPipelineIntegrationId] = useState(null);

  const onSelectPipelineIntegration = event => {
    const pipelineIntegrationId = event.target.value;
    setSelectedPipelineIntegrationId(pipelineIntegrationId);
  };

  return {
    selectedPipelineIntegrationId,
    onSelectPipelineIntegration,
    selectedPipelineIntegration: findSelectedPipelineIntegration({
      selectedPipelineIntegrationId,
      pipelineIntegrations,
    }),
  };
}

function findSelectedPipelineIntegration({ selectedPipelineIntegrationId, pipelineIntegrations }) {
  if (!selectedPipelineIntegrationId) {
    return null;
  }

  return pipelineIntegrations.find(pipelineIntegration => pipelineIntegration.id === selectedPipelineIntegrationId);
}
